export const getDateRange = (startDate, endDate) => {
    const now = new Date();
    const start = startDate
        ? new Date(Date.UTC(new Date(startDate).getUTCFullYear(), new Date(startDate).getUTCMonth(), new Date(startDate).getUTCDate()))
        : new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - 29));
    const end = endDate
        ? new Date(Date.UTC(new Date(endDate).getUTCFullYear(), new Date(endDate).getUTCMonth(), new Date(endDate).getUTCDate()))
        : new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    return { start, end };
};
export const getDateRangeFromLabel = (label) => {
    const now = new Date();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    let start = today;
    let end = today;
    switch (label) {
        case 'Today':
            start = end = today;
            break;
        case 'Yesterday':
            start = end = new Date(today);
            start.setUTCDate(today.getUTCDate() - 1);
            break;
        case 'Past 7 days':
            start = new Date(today);
            start.setUTCDate(today.getUTCDate() - 6);
            break;
        case 'Past 30 days':
            start = new Date(today);
            start.setUTCDate(today.getUTCDate() - 29);
            break;
        case 'Past 90 days':
            start = new Date(today);
            start.setUTCDate(today.getUTCDate() - 89);
            break;
        case 'This week': {
            const day = today.getUTCDay();
            start = new Date(today);
            start.setUTCDate(today.getUTCDate() - (day || 7) + 1);
            break;
        }
        case 'Last week': {
            const day = today.getUTCDay();
            end = new Date(today);
            end.setUTCDate(today.getUTCDate() - (day || 7));
            start = new Date(end);
            start.setUTCDate(end.getUTCDate() - 6);
            break;
        }
        case 'This month':
            start = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
            break;
        case 'Last month':
            const lastMonth = today.getUTCMonth() - 1;
            start = new Date(Date.UTC(today.getUTCFullYear(), lastMonth, 1));
            end = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 0));
            break;
        default:
            break;
    }
    return { start, end };
};
//# sourceMappingURL=date-range.js.map